export const localConstants = {
	contactAdminSomethingWrong: 'Contact Admin Something Went Wrong',
}
